import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { CircularProgress } from '@mui/material';
import { useFindAllRmasForUserQuery } from '../../api/api-hooks';
import { filterRmas } from './customerRmaUtils';
import { Rma } from '../../api/api-generated';
import { truncateISOString } from '../../utils/dateTime';
import { CustomerRmaFilter } from './customerRmaTypes';
import { useGridSort } from '../../hooks/useGridSort';

interface Props {
  filters: CustomerRmaFilter;
  history: boolean;
}

const RmaTable = ({ filters, history }: Props) => {
  const { data: rmas } = useFindAllRmasForUserQuery({});
  const { sortModel, handleSortModelChange } = useGridSort('id', 'desc');
  if (rmas === undefined) return <CircularProgress></CircularProgress>;
  const columns: GridColDef[] = [
    { field: 'id', hide: true },
    { field: 'nameId', headerName: 'RMA #', width: 200 },
    { field: 'serial', headerName: 'Serial #', width: 200 },
    { field: 'status', headerName: 'Shipping Status', width: 200 },
    { field: 'trackingNumber', headerName: 'Tracking Number', width: 200 },
    { field: 'shipper', headerName: 'Shipper', width: 160 },
    { field: 'shipDate', headerName: 'Ship Date', width: 160 },
  ];
  const rows = rmas
    .filter((item: Rma) =>
      history
        ? item.isComplete && filterRmas(item, filters)
        : !item.isComplete && filterRmas(item, filters)
    )
    .map((item: Rma) => ({
      ...item,
      shipDate: item.shipDate ? truncateISOString(item.shipDate) : ' ',
      serial: item.hardware.serial,
    }));
  return (
    <>
      <div style={{ paddingBottom: '1rem', width: '100%' }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={100}
          disableSelectionOnClick
          autoHeight
          disableColumnMenu={true}
          sortModel={sortModel}
          onSortModelChange={handleSortModelChange}
        />
      </div>
    </>
  );
};

export default RmaTable;
